import { Children, ReactNode, createElement, useLayoutEffect } from 'react';
import Icon, { Icons } from '../../elements/Icon';
import useOnScreen from '@/presentation/hooks/useOnScreen';

export const InfiniteScroll = ({
  children,
  scrollable,
  onLoadMore,
  loaderElement = 'div',
  loaderClassName,
  loaderChildren,
}: {
  children: ReactNode;
  scrollable: boolean;
  onLoadMore: () => void;
  loaderElement?: string;
  loaderClassName?: string;
  loaderChildren?: ReactNode;
}) => {
  const [ref, isOnScreen] = useOnScreen();
  const count = Children.count(children);
  const Loader = createElement(
    loaderElement,
    {
      ref,
      className: `${loaderClassName ?? ''} ${
        scrollable ? 'flex' : 'hidden'
      } justify-center items-center p-3`,
    },
    loaderChildren || (
      <Icon
        name={Icons.SPINNER_GAP}
        className="animate animate-spin text-gray-500"
        size={20}
      />
    )
  );

  useLayoutEffect(() => {
    const handle = setTimeout(() => {
      if (scrollable && isOnScreen) {
        onLoadMore();
      }
    }, 100);

    return () => {
      clearTimeout(handle);
    };
  }, [scrollable, isOnScreen, count, onLoadMore]);

  return (
    <>
      {children}
      {Loader}
    </>
  );
};

export default InfiniteScroll;
